function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Tablet---Inzicht-stel-een-vraag",
  transform: "translate(-762.000000, -187.000000)",
  fill: "#00172e"
}, /*#__PURE__*/React.createElement("g", {
  id: "Afsluiten",
  transform: "translate(746.000000, 172.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.5707922,25 L35.4668424,18.1039498 C36.1777192,17.393073 36.1777192,16.2440344 35.4668424,15.5331576 C34.7559656,14.8222808 33.606927,14.8222808 32.8960502,15.5331576 L26,22.4292078 L19.1039498,15.5331576 C18.393073,14.8222808 17.2440344,14.8222808 16.5331576,15.5331576 C15.8222808,16.2440344 15.8222808,17.393073 16.5331576,18.1039498 L23.4292078,25 L16.5331576,31.8960502 C15.8222808,32.606927 15.8222808,33.7559656 16.5331576,34.4668424 C16.8876869,34.8213718 17.3531203,34.9995455 17.8185537,34.9995455 C18.2839871,34.9995455 18.7494205,34.8213718 19.1039498,34.4668424 L26,27.5707922 L32.8960502,34.4668424 C33.2505795,34.8213718 33.7160129,34.9995455 34.1814463,34.9995455 C34.6468797,34.9995455 35.1123131,34.8213718 35.4668424,34.4668424 C36.1777192,33.7559656 36.1777192,32.606927 35.4668424,31.8960502 L28.5707922,25 Z",
  id: "Fill-1"
}))));
function SvgCrossCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCancel);
export default __webpack_public_path__ + "static/media/Cross_Cancel.2d08b441a2549c72f9fe89b6301aa74b.svg";
export { ForwardRef as ReactComponent };